import { EnvConfig } from '@d/appConfigs/envConfig';
import { createContext } from 'react';
import { LoggerFactory } from '../infrastructure/loggers';

export const logger = LoggerFactory.createLogger(EnvConfig.env);
export const LoggerContext = createContext(logger);
